<template>
  <svg xmlns="http://www.w3.org/2000/svg" :class="classes" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <template v-if="locked">
      <!-- Locked icon -->
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
    </template>
    <template v-else>
      <!-- Unlocked icon -->
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z" />
    </template>
  </svg>
</template>

<script setup lang="ts">
defineProps({
  locked: {
    type: Boolean,
    default: true
  },
  classes: {
    type: String,
    default: 'h-4 w-4'
  }
})
</script>

